<template>
  <div>
    <div class="box_title flex sm-" style="justify-content: space-between;z-index: 10">
      <Title title="素材提交" :backShow="false"/>
      <div class="flex" v-if="$route.query.id">
        <button @click.stop="$router.back()" class="but">返回</button>
        <button @click.stop="updateFn" class="but">修改</button>
      </div>
    </div>

    <div class="ct_box" style="background-color: rgba(0,0,0,0);box-shadow: none;display: flex">
      <div class="ct_box_left">
        <el-divider content-position="left">基础素材</el-divider>
        <el-form :model="placard.fill_form" :rules="rules" ref="placard.fill_form">
          <el-form-item prop="title">
            <!-- <el-input v-model="$store.state.FillForm.title" placeholder="标题建议25字符以内，字符过多的，媒介修改标题不通知"></el-input> -->
            <div class="flex input_box">
              <div class="title_box">
                <p class="title"><span>*</span>素材名称</p>
              </div>
              <!-- <input class="input_text" v-model="$store.state.FillForm.title"
    placeholder="标题建议25字符以内，字符过多的，媒介修改标题不通知" /> -->
              <el-input class="title_input" v-model="placard.fill_form.title"
                        placeholder="标题建议25字符以内，字符过多的，广告主修改标题不通知"></el-input>
              <span class="num">{{ placard.fill_form.title.length }}/50</span>
            </div>
          </el-form-item>
        </el-form>

        <div>
          <zip_upload @upload_success="upload_success" :up_load_url="placard.fill_form.file"
                      :up_load_name="placard.fill_form.file_name"/>
          <div class="flex input_box" style="flex-wrap: nowrap">
            <div class="title_box2">
              <p class="title"><span></span>素材描述</p>
            </div>
            <div>
              <vue-ueditor-wrap id="tinymce" v-model="placard.fill_form.content"
                                :config="myConfig"></vue-ueditor-wrap>
            </div>
          </div>
        </div>
      </div>
      <div class="ct_box_right">
        <el-divider content-position="left">相关资质</el-divider>
        <div class="input_box flex">
          <div class="input_box_2">
            <div class="title_box">
              <p class="title"><span></span>营业执照</p>
            </div>
            <div>
              <el-upload
                  action="/api/common/upload"
                  list-type="picture-card"
                  :headers=headers
                  :limit="1"
                  :file-list="this.placard.fill_form.business_license_list"
                  :preview-src-list="this.placard.fill_form.business_license_list"
                  :on-success="upload_success_businessLicense"
                  :on-exceed="overLimit"
                  :on-remove="handleRemove_businessLicense"
                  @preview="handlePreview">
                <i class="el-icon-plus"></i>
                <template #file="{ file }">
                  <!--缩略图-->
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                  <span class="el-upload-list__item-actions">
                    <!--预览-->
                    <span class="el-upload-list__item-preview" @click="handlePreview(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <!--删除-->
                    <span class="el-upload-list__item-delete" @click="handleRemove_businessLicense(file)">
                      <i class="el-icon-delete"></i>
                    </span>
                    <!--下载-->
                    <span class="el-upload-list__item-download" @click="handleDownload(file)">
                      <i class="el-icon-download"></i>
                     </span>
                  </span>
                </template>
              </el-upload>
            </div>
          </div>

        </div>
        <div class="input_box flex">
          <div class="input_box_2">
            <div class="title_box">
              <p class="title"><span></span>商标证书</p>
            </div>
            <div>
              <el-upload
                  action="/api/common/upload"
                  list-type="picture-card"
                  :headers=headers
                  :limit="1"
                  :file-list="this.placard.fill_form.shangbiao_zhengshu_list"
                  :on-success="upload_success_trademarkCertificate"
                  :on-exceed="overLimit"
                  :on-remove="handleRemove_trademarkCertificate">
                <i class="el-icon-plus"></i>
                <template #file="{ file }">
                  <!--缩略图-->
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                  <span class="el-upload-list__item-actions">
                    <!--预览-->
                    <span class="el-upload-list__item-preview" @click="handlePreview(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <!--删除-->
                    <span class="el-upload-list__item-delete" @click="handleRemove_trademarkCertificate(file)">
                      <i class="el-icon-delete"></i>
                    </span>
                    <!--下载-->
                    <span class="el-upload-list__item-download" @click="handleDownload(file)">
                      <i class="el-icon-download"></i>
                     </span>
                  </span>
                </template>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="input_box flex">
          <div class="title_box">
            <p class="title"><span></span>其他资质</p>
          </div>
          <div>
            <el-upload
                action="/api/common/upload"
                list-type="picture-card"
                :headers=headers
                :limit="3"
                :file-list="this.placard.fill_form.qita_zizhi_list"
                :on-success="upload_success_otherQualifications"
                :on-exceed="overLimit"
                :on-remove="handleRemove_otherQualifications">
              <i class="el-icon-plus"></i>
              <template #file="{ file }">
                <!--缩略图-->
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                <span class="el-upload-list__item-actions">
                    <!--预览-->
                    <span class="el-upload-list__item-preview" @click="handlePreview(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                  <!--删除-->
                    <span class="el-upload-list__item-delete" @click="handleRemove_otherQualifications(file)">
                      <i class="el-icon-delete"></i>
                    </span>
                  <!--下载-->
                    <span class="el-upload-list__item-download" @click="handleDownload(file)">
                      <i class="el-icon-download"></i>
                     </span>
                  </span>
              </template>
            </el-upload>
          </div>
        </div>
        <!--        大图预览-->
        <el-dialog :visible.sync="dialogVisible" title="图片预览" :append-to-body="true">
          <img :src="dialogImageUrl" alt="预览图片" style="max-width: 100%; max-height: 80vh;">
          <template #footer>
            <el-button @click="dialogVisible = false">关闭</el-button>
          </template>
        </el-dialog>
      </div>

    </div>
    <set_placard/>
  </div>
</template>

<script>
import Title from '@/components/UserInfoTitle'
import VueUeditorWrap from 'vue-ueditor-wrap'
import set_placard from '@/components/set_placard'
import {mapMutations, mapState} from 'vuex'
import zip_upload from '@/components/zip_upload'
import {curlGet} from "@/api/request";
import $util from "@/util/util";

export default {
  computed: {
    ...mapState(['placard']),
    ...mapMutations(['RESET_FILL_FORM', 'SET_PLACARD_FILE'])
  },
  components: {
    Title,
    VueUeditorWrap,
    set_placard,
    zip_upload
  },
  mounted() {

    if (this.$route.query.id) {
      // 如果有id传入,则为修改
      this.curlGet('/api/users/guanggao_order/detail', {
        id: this.$route.query.id
      }).then(res => {
        this.placard.car_list = []
        // console.log('修改', res.data.data[0])
        if (res.data.code) {
          this.placard.fill_form.category_id = res.data.data[0].category_id
          for (const key in res.data.data[0]) {
            this.placard.fill_form[key] = res.data.data[0][key]
          }
          this.$store.commit('SET_PLACARD_FILE', {
            index: 'file_name',
            file: res.data.data[0].file,
          })
          // console.log(this.placard.fill_form);

          if (res.data.data[0].business_license !== '') {
            this.placard.fill_form.business_license_list = [{
              name: '',
              url: res.data.data[0].business_license
            }]
          } else {
            this.placard.fill_form.business_license_list = []
          }
          if (res.data.data[0].shangbiao_zhengshu !== '') {
            this.placard.fill_form.shangbiao_zhengshu_list = [{
              name: '',
              url: res.data.data[0].shangbiao_zhengshu
            }]
          } else {
            this.placard.fill_form.shangbiao_zhengshu_list = []
          }
          if (res.data.data[0].qita_zizhi !== '') {
            this.placard.fill_form.qita_zizhi_list = []
            const paths = res.data.data[0].qita_zizhi.split(',');
            paths.forEach(item => {
              this.placard.fill_form.qita_zizhi_list.push({
                name: '', url: item
              })
            })
          } else {
            this.placard.fill_form.qita_zizhi_list = []
          }

        }
      })
    } else {

      if (this.$route.fullPath.endsWith('from=preview')) {

      } else {
        this.placard.fill_form = {
          title: '',
          file: '',
          file_name: '',
          content: '',
          business_license_list: [],
          shangbiao_zhengshu_list: [],
          qita_zizhi_list: [],
        }
      }
    }

    this.curlGet('/api/user/info').then((res) => {
      if (res.data.code === 1) {
        this.user_info = res.data.data
        $util.setLocalStorage('user_info', res.data.data) // 写入local storage
        this.headers.token = this.user_info.token
      }
    })

  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      user_info: {},
      headers: {
        token: ''
      },
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 400,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: `/api/common/getupload?token=${this.$user_info.token}`,
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/',
        initialContent: '1.所提供文章必须符合国家广告法内容，若文章存在违规被删除，本平台不予处理；<br/>2.Word文档上传后请仔细检查内容是否有误，一经发布无法撤回和修改，请确认后再操作；<br/>3.署名、作者名、免责声明等特殊内容不保证，网媒没标明不包时效的，默认1个月。<br/>4.图片文件最大上传不超过3MB；<br/>5.视频文件最大上传不超过20MB；',
        autoClearinitialContent: true,
        toolbars: [
          [
            "fullscreen",
            "source",	// html 源码
            "|",
            "undo",
            "redo",
            "|",
            "link",
            "unlink",
            "|",
            "simpleupload",
            "insertimage",
            "insertvideo",
            "|",
            "bold",
            "forecolor",
            "|",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "|",
            "fontfamily",
            "fontsize",
            "|",
            "removeformat",
            "formatmatch",
            "autotypeset",
          ]
        ],
      },
      zip_list: [{
        name: '',
        url: ''
      }],
      rules: {
        title: [
          {required: true, message: '请输入素材名称', trigger: 'blur'},
          {min: 1, max: 50, message: '标题长度在 1 到 50 个字符', trigger: 'blur'}
        ],
      },

    }
  },
  methods: {
    // 下载图片
    handleDownload(file) {
      const link = document.createElement('a');
      link.href = file.url;
      link.download = file.name;
      link.click();
    },
    // 预览图片
    handlePreview(file) {
      console.log(file)
      // 处理图片预览逻辑
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 压缩包上传
    beforeZipUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "zip" || testmsg === "rar";
      if (!extension) {
        this.$message.error('上传压缩包类型只能是zip或RAR!')
        return
      }
      const is20M = file.size / 1024 / 1024 < 20;
      //限制文件上传大小
      if (!is20M) {
        this.$message.error("上传文件大小不能超过 20MB!");
        return
      }
      console.log(file)
      // console.log(this.zip_list)
      this.zip_list.name = file.name
    }
    ,
// 压缩包上传成功
    zipUploadSuccess(res, file, fileList) {
      console.log('上传成功', res, file, fileList)
    }
    ,

    upload_success(data) {
      // this.placard.fill_form.file = data.file
      this.$store.commit('SET_PLACARD_FILE', {
        file: data.file,
        index: 'file'
      })
      this.$store.commit('SET_PLACARD_FILE', {
        file: data.name,
        index: 'file_name'
      })
    }
    ,
    back() {
      this.$router.push('/placard_user/placard_fill')
    }
    ,
// 修改
    updateFn() {
      if (this.placard.title == '') {
        return this.$message({
          type: 'warning',
          message: '请输入稿件标题'
        });
      }
      if (this.placard.content == '') {
        return this.$message({
          type: 'warning',
          message: '请选择文件提取文章或输入文章'
        });
      }

      this.$confirm('是否修改文稿?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再想想',
      }).then(() => {
        let data = {}
        data.id = this.$route.query.id
        data.title = this.placard.fill_form.title
        data.content = this.placard.fill_form.content
        if (this.placard.fill_form.file) {
          data.file = this.placard.fill_form.file
        }
        if (this.placard.fill_form.business_license_list.length !== 0) {
          data.business_license = this.placard.fill_form.business_license_list[0].url
        } else {
          data.business_license = ''
        }

        if (this.placard.fill_form.shangbiao_zhengshu_list.length !== 0) {
          data.shangbiao_zhengshu = this.placard.fill_form.shangbiao_zhengshu_list[0].url
        } else {
          data.shangbiao_zhengshu = ''
        }
        data.qita_zizhi = ''
        if (this.placard.fill_form.qita_zizhi_list.length !== 0) {
          this.placard.fill_form.qita_zizhi_list.forEach((item, index) => {
            if (data.qita_zizhi === '') {
              data.qita_zizhi = item.url
            } else {
              data.qita_zizhi = data.qita_zizhi + ',' + item.url
            }
          })
        } else {
          data.qita_zizhi = ''
        }
        console.log('data', data)

        this.curlPost('/api/users/guanggao_order/modify', data).then(res => {
          if (res.data.code === 1) {
            this.$message({
              type: 'success',
              message: '修改成功'
            });
            this.$store.commit('RESET_FILL_FORM')
            this.$router.push('/placard_user/placard_order')
          } else {
            this.$message({
              type: 'info',
              message: res.data.msg
            });
          }

        })
      }).catch((err) => {
        console.log(err)
        this.$message({
          type: 'info',
          message: '已取消修改'
        });
      });
    }
    ,
    upload_success_businessLicense(file, fileList) {
      // console.log('上传成功', fileList);
      this.placard.fill_form.business_license_list.push({
        name: fileList.name,
        url: file.data.url
      });
    }
    ,
    upload_success_trademarkCertificate(file, fileList) {
      this.placard.fill_form.shangbiao_zhengshu_list.push({
        name: fileList.name,
        url: file.data.url
      });
    }
    ,
    upload_success_otherQualifications(file, fileList) {
      console.log(this.placard.fill_form)
      this.placard.fill_form.qita_zizhi_list.push({
        name: fileList.name,
        url: file.data.url
      });
    }
    ,
    handleRemove_businessLicense(file, fileList) {
      this.placard.fill_form.business_license_list = [];

    }
    ,
    handleRemove_trademarkCertificate(file, fileList) {
      this.placard.fill_form.shangbiao_zhengshu_list = [];
      console.log(this.placard.fill_form)
    }
    ,
    handleRemove_otherQualifications(file, fileList) {
      console.log(file, fileList)
      this.placard.fill_form.qita_zizhi_list.forEach((item, index) => {
        if (item.uid === file.uid) {
          this.placard.fill_form.qita_zizhi_list.splice(index, 1)
        }
      })
    }
    ,
    overLimit() {
      this.$message({
        type: 'warning',
        message: '上传文件超出限制'
      })
    }
  },
}
</script>

<style lang=scss scoped>
@use '@/scss/Fill';

::v-deep .el-divider__text {
  background-color: transparent;
}
</style>